import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample } from 'src/app/constants/service.constants';
import * as $ from 'jquery';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { UserService } from "src/app/services/user.service";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-grants-budget-view-modal',
  templateUrl: './grants-budget-view-modal.component.html',
  styleUrls: ['./grants-budget-view-modal.component.scss']
})
export class GrantsBudgetViewModalComponent implements OnInit {

  @Input() public Content: any;
  appid: string = "";
  formFields;
  stateOptions = stateOptionsSample;
  grantcurrencycode: any = "";
  granttype: number;
  budgetForm: UntypedFormGroup;
  permission: string;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  budgetTypeOptions = [];
  budgetSubTypeOptions = [];
  StatusStr: any;
  // budgetTypeOptions = [
  //   { value: 'Staff', label: 'Staff' },
  //   { value: 'Travel', label: 'Travel' },
  //   { value: 'Investigations', label: 'Investigations' },
  //   { value: 'Miscellaneous', label: 'Miscellaneous' }
  // ];

  // budgetSubTypeOptions = [
  //   { value: 'StaffSalary', label: 'Staff Salary' },
  //   { value: 'BusTravel', label: 'Bus Travel' },
  //   { value: 'LocalTravelAllowance', label: 'Local Travel Allowance' },
  //   { value: 'AirFair', label: 'Air Fair' },
  //   { value: 'ScanReports', label: 'Scan Reports' },
  //   { value: 'BloodReports', label: 'Blood Reports' },
  //   { value: 'UrineReports', label: 'Urine Reports' },
  //   { value: 'Miscellaneous', label: 'Miscellaneous' }
  // ];
  staticformFields: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private userService: UserService,
    private commonService: CommonService
  ) {

  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"]; 
      });
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-026');
    const grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    this.appid = grantapp.ID;
    this.granttype = grantapp.GRANT_TYPE;

    if(this.appid==null || this.appid=="" || this.appid==undefined)
    {
    }
    else{
      this.getOnIntMethods();
    }
    this.disable();
  }


  getOnIntMethods()
  {
    this.heading = this.Content.heading;

    this.budgetForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      BUGET_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      NOTES: new UntypedFormControl("", [Validators.required]),
      REQUESTED_AMOUNT: new UntypedFormControl("", [Validators.required]),
      TOTAL_FEE: new UntypedFormControl("", [Validators.required])
    });

    this.getFundCategoryList();

    if (this.heading == "View") {
      this.GetEditData();
      this.budgetForm.controls["BUGET_TYPE_ID"].disable();
      this.budgetForm.controls["BUDGET_SUB_TYPE_ID"].disable();
      this.budgetForm.controls["TOTAL_FEE"].disable();
      this.budgetForm.controls["REQUESTED_AMOUNT"].disable();
      this.budgetForm.controls["NOTES"].disable();

    }
    if (this.heading == "Edit") {
      this.GetEditData();
    } else{
      this.StatusStr = "Draft";
    }

    if (this.heading == "Add") {
      this.getLatestSymbol();
    }

    // if (this.granttype == 1)
    //   this.grantcurrencycode = this.userService.getGrantCMECurrencySymbol();
    // else if (this.granttype == 2)
    //   this.grantcurrencycode = this.userService.getGrantSponsorCurrencySymbol();
    // else if (this.granttype == 3)
    //   this.grantcurrencycode = this.userService.getGrantCharitableCurrencySymbol();

    // if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
    //   this.grantcurrencycode = "$";

    this.permission = this.commonService.getPagePermission("GC05").toLowerCase();
    //this.permission = "view";
    if (this.permission === 'view') {
      setTimeout(() => {
        this.budgetForm.disable({ emitEvent: false });
      }, 100);
    }

  }

  getLatestSymbol()
  {
    if (this.granttype == 1)
    {
      this.userService.getGrantCMECurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 2)
    {
      this.userService.getGrantSponsorCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 3)
    {
      this.userService.getGrantCharitableCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
  }


  GetEditData(): void {
    this.summaryService.getBudget(this.Content.content.id).subscribe(summary => {
      if (summary) {
        this.budgetForm.patchValue({
          ID: summary["ID"],
          APPLICATION_ID: summary["APPLICATION_ID"],
          BUGET_TYPE_ID: summary["BUGET_TYPE_ID"],
          BUDGET_SUB_TYPE_ID: summary["BUDGET_SUB_TYPE_ID"],
          TOTAL_FEE: summary["TOTAL_FEE"],
          REQUESTED_AMOUNT: summary["REQUESTED_AMOUNT"],
          NOTES: summary["NOTES"]
        });
  debugger;
        this.getFundSubCategoryList(summary["BUGET_TYPE_ID"]);

        if (this.heading == "view") {
          this.budgetForm.controls["BUGET_TYPE_ID"].disable();
          this.budgetForm.controls["BUDGET_SUB_TYPE_ID"].disable();
        }

        if(summary["Status"] > 1){
          this.grantcurrencycode = summary["CURRENCY_SYMBOL"];
        }
        if( this.grantcurrencycode==null ||  this.grantcurrencycode==undefined ||  this.grantcurrencycode=="")
        {
          this.getLatestSymbol();
        }
        this.StatusStr = summary["StatuStr"];
        this.extendedForm.rowid=summary.ID;
          this.extendedForm.getResponse();
      }
      

    });
    
  }

  getFundCategoryList() {
    this.summaryService.getBudgetTypeList(this.appid,this.Content.content.id).subscribe((result) => {
      if (result != null) {
        this.budgetTypeOptions = result;
        this.budgetTypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.budgetTypeOptions);
      }
    });
  }

  getFundSubCategoryList(typeid: any) {
    this.summaryService.getBudgetSubTypeList(typeid,this.appid,this.Content.content.id).subscribe((result) => {
      if (result != null) {
        this.budgetSubTypeOptions = result;
        this.budgetSubTypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.budgetSubTypeOptions);
        this.disable();
      }
    });
  }

  disable(){
    if(this.budgetForm.controls['BUGET_TYPE_ID'].value == null || this.budgetForm.controls['BUGET_TYPE_ID'].value == "" || this.budgetForm.controls['BUGET_TYPE_ID'].value == undefined){
      this.budgetForm.controls['BUDGET_SUB_TYPE_ID'].disable();
    } else{
      this.budgetForm.controls['BUDGET_SUB_TYPE_ID'].enable();
    }
  }

  getSelectedValue(value: any): void {
    this.getFundSubCategoryList(value);
  }

  SaveBudget() {
    if (this.validateControls()) {
      const formData = this.budgetForm.value;

      formData["APPLICATION_ID"] = this.appid;
      formData["TOTAL_FEE"] = parseInt(formData["TOTAL_FEE"]);
      formData["REQUESTED_AMOUNT"] = parseInt(formData["REQUESTED_AMOUNT"]);
      formData["GRANTTYPE"] = this.granttype;
      formData["CURRENCY_SYMBOL"] = this.grantcurrencycode;

      if (this.heading == "Add") {
        this.summaryService.Insert('api/gmbudget/insert', formData).subscribe(summary => {
          if (summary.Status == 0) {
            this.extendedForm.saveControls(summary.TransactionID,this.appid,summary.TransactionCode).subscribe(result => {
              if (result.Status === 0) {
                this.commonService.SuccessBanner(summary.Message);
                this.modalRef.close();
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
              // this.commonService.SuccessBanner('Budget Requirement saved successfully');
              // this.modalRef.close();
          });
          }
        });
      }
      else {
        this.summaryService.Update('api/gmbudget/update', formData).subscribe(result => {
          if (result.Status === 0 ||result.ErrorCode=="NOCHANGES") {
            this.extendedForm.saveControls(result.TransactionID,this.appid,result.TransactionCode).subscribe(summary1 => {
              if(summary1.ErrorCode === "NOCONTROLS")
              {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner(result.Message);
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              }else{
                if (result.ErrorCode === "NOCHANGES" && summary1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(result.Message);
                  this.modalRef.close();
                }
              }
             
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }

          // this.extendedForm.saveControls(this.Content.content.id).subscribe(summary => {
          //   if (result.Status == 0) {
          //     this.commonService.SuccessBanner('Budget Requirement saved successfully.');
          //     this.modalRef.close();
          //   } else {
          //     this.commonService.ValidationBanner(result.Message);
          //   }
          // });

        });
      }
    }
  }

  validateControls() {
    let formDate = this.budgetForm.value;

    let isValid = true;
    let message = "";

    if(this.staticformFields?.BUGET_TYPE_ID.IS_Display &&  this.staticformFields?.BUGET_TYPE_ID.IS_MANDATORY){
      if (formDate.BUGET_TYPE_ID === null || formDate.BUGET_TYPE_ID === "" || formDate.BUGET_TYPE_ID === undefined) {
        $("#BUGET_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BUGET_TYPE_ID").removeClass("ng-untouched ng-valid");
      //  message += "Please select Budget Type<br/>";
        message += `Please select ${this.staticformFields?.BUGET_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BUGET_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BUGET_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.BUDGET_SUB_TYPE_ID.IS_Display && this.staticformFields?.BUDGET_SUB_TYPE_ID.IS_MANDATORY) {
      if (formDate.BUDGET_SUB_TYPE_ID === null || formDate.BUDGET_SUB_TYPE_ID === "" || formDate.BUDGET_SUB_TYPE_ID === undefined) {
        $("#BUDGET_SUB_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BUDGET_SUB_TYPE_ID").removeClass("ng-untouched ng-valid");

        //message += "Please select Budget Sub Type<br/>";
        message += `Please select ${this.staticformFields?.BUDGET_SUB_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BUDGET_SUB_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BUDGET_SUB_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TOTAL_FEE.IS_Display && this.staticformFields?.TOTAL_FEE.IS_MANDATORY) {
      if (formDate.TOTAL_FEE === null || formDate.TOTAL_FEE === "" || formDate.TOTAL_FEE === undefined) {
        $("#TOTAL_FEE").addClass("ng-touched ng-invalid validate-error");
        $("#TOTAL_FEE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TOTAL_FEE.LABEL_NAME} <br/>`;
       // message += "Please enter Total fees<br/>";
        isValid = false;
      } else {
        //$("#TOTAL_FEE").addClass("ng-untouched ng-valid");
        //$("#TOTAL_FEE").removeClass("ng-touched ng-invalid validate-error");
        if (!isNaN(formDate.TOTAL_FEE)) {
          $("#TOTAL_FEE").addClass("ng-untouched ng-valid");
          $("#TOTAL_FEE").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#TOTAL_FEE").addClass("ng-touched ng-invalid validate-error");
          $("#TOTAL_FEE").removeClass("ng-untouched ng-valid");
         // message += "Total Amount field will allow only numeric values..<br/>";
          message += `${this.staticformFields?.TOTAL_FEE.LABEL_NAME} will allow only numeric values<br/>`;
          isValid = false;
        }
      }
    }

    //const mailformat = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
    if (this.staticformFields?.REQUESTED_AMOUNT.IS_Display && this.staticformFields?.REQUESTED_AMOUNT.IS_MANDATORY) {

      if (formDate.REQUESTED_AMOUNT === null || formDate.REQUESTED_AMOUNT === "" || formDate.REQUESTED_AMOUNT === undefined) {
        $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
        //message += "Please enter Requested Amount<br/>";
        message += `Please enter ${this.staticformFields?.REQUESTED_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        //$("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
        //$("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        if (!isNaN(formDate.REQUESTED_AMOUNT)) {
          $("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
          $("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
          //message += "Requested Amount field will allow only numeric values<br/>";
          message += `${this.staticformFields?.REQUESTED_AMOUNT.LABEL_NAME} field will allow only numeric values<br/>`;
          isValid = false;
        }
      }
    }

    let totalfee = parseInt(formDate["TOTAL_FEE"]);
    let requested = parseInt(formDate["REQUESTED_AMOUNT"]);
    if (totalfee > 0 && requested > 0) {
      if (requested > totalfee) {
        $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
        message += "Requested amount cannot be more than total fee<br/>";
        isValid = false;
      } else {
        $("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
        $("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.REQUESTED_NOTES.IS_Display && this.staticformFields?.REQUESTED_NOTES.IS_MANDATORY) {
      if (formDate.NOTES === null || formDate.NOTES === "" || formDate.NOTES === undefined) {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message +=  `Please enter ${this.staticformFields?.REQUESTED_NOTES?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    // if (formDate.NOTES === null || formDate.NOTES === "" || formDate.NOTES === undefined) {
    //   $("#NOTES").addClass("ng-touched ng-invalid validate-error");
    //   $("#NOTES").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Notes.<br/>";
    //   isValid = false;
    // } else {
    //   $("#NOTES").addClass("ng-untouched ng-valid");
    //   $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
    // }

    //dyamic fields validations
  let ExtenMsgs = this.extendedForm.validateControlsMsgs();
  if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
    isValid = false;
    message = message + ExtenMsgs;
  }

    if (!isValid) {
      this.commonService.ValidationBanner(message)
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    }
    return isValid;
  }
}
